import { AxiosResponse } from 'axios';
import { IPortSearchForm, IPortGeometry } from './portTypes';
import { authApiV2, axiosWithToast } from '../../axiosWrapper';
// import { handleAxiosError } from '../../utils/apiHelpers';

/**
 * Search ports by name
 * @param name - Port name to search for
 * @returns Promise with ports array
 */
export const getSearchedPortsByNameApi = async (name: string): Promise<{ ports: IPortSearchForm[] }> => {
	try {
		const endpoint = `/ports/search-by-name`;
		const response: AxiosResponse<{ ports: IPortSearchForm[] }> = await authApiV2.get(endpoint, {
			params: { name: name.trim() },
		});
		return response.data;
	} catch (error) {
		//TODO: Handle error properly in UI and remove debugger
		// handleAxiosError(error, 'Failed to get port geometry');
		// discuss later with @Muhammed and @Evrim about error handling strategy in sagas and api calls
		throw error;
	}
};

/**
 * Get port geometry by name and country
 * @param portName - Name of the port
 * @param country - Country of the port
 * @returns Promise with port geometry
 */
export const getPortGeometryByNameAndCountryApi = async (portName: string, country: string): Promise<IPortGeometry> => {
	try {
		const endpoint = `/ports/get-port-geometry`;

		const response: AxiosResponse<IPortGeometry> = await axiosWithToast(
			{
				method: 'GET',
				url: endpoint,
				withCredentials: true,
				params: {
					portName: portName.trim(),
					country: country.trim(),
				},
			},
			'Retrieving port geometry...',
			'',
			0,
			0,
			false,
		);
		return response.data;
	} catch (error) {
		//TODO: Handle error properly in UI and remove debugger
		// handleAxiosError(error, 'Failed to get port geometry');
		// discuss later with @Muhammed and @Evrim about error handling strategy in sagas and api calls
		throw error;
	}
};
